export default __webpack_public_path__ + "static/media/Rup-logo-white.6ca8e1f4.svg";